<template>
    <div :class="[pageClass, 'shopping_mall']">
        <div :class="[`${pageClass}-header`, 'header']">
          <table width="1200" border="0" align="center" cellpadding="0" cellspacing="0" class="text-01 h120">
            <tr>
              <td>
                <table width="100%" border="0" align="center" cellpadding="0" cellspacing="0" class="text-01 h120" style="font-size:16px;">
                  <tr>
                    <td width="230"><img src="/web/images/logo.png" width="230" class="h120">
                    </td>
                    <td>&nbsp;</td>
                    <td width="100" class="tab-list" style="cursor: pointer;" @click="tabChange(1)">
                      <div align="center">
                        <p class="content">
                          <a href="/web/index.html" >首页</a>
                        </p>
                      </div>
                    </td>
                    <td width="100" class="tab-list" style="cursor: pointer;" @click="tabChange(2)">
                      <div align="center">
                        <p class="content">
                          <a href="/web/main/01-01.html">产品</a>
                          <img id="_arrow_nav" src="/web/images/arrow_nav_d.png" alt="">
                        </p>
                      </div>
                      <div class="_product_list product_list">
                        <table width="100%" height="60" border="0" align="center" cellpadding="0" cellspacing="0"
                          bgcolor="#4981e9" class="text-01">
                          <tr>
                            <td>
                              <table width="400" height="40" border="0" align="center" cellpadding="0" cellspacing="0"
                                class="text-01">
                                <tr>
                                  <td width="100">
                                    <div align="center">
                                      <p class="content"><a href="/web/main/01-01.html">
                                          <font color="#FFFFFF">产品介绍</font>
                                        </a></p>
                                    </div>
                                  </td>
                                  <td width="100">
                                    <div align="center">
                                      <p class="content"><a href="/web/main/01-02.html">
                                          <font color="#FFFFFF">产品动态</font>
                                        </a></p>
                                    </div>
                                  </td>
                                  <td width="100">
                                    <div align="center">
                                      <p class="content"><a href="/web/main/01-03.html">
                                          <font color="#FFFFFF">软件下载</font>
                                        </a></p>
                                    </div>
                                  </td>
                                  <td width="120">
                                  <div align="center">
                                    <p class="content">
                                      <a href="/#/web/vip_card_active">
                                        <font color="#FFFFFF">软件卡激活</font>
                                      </a>
                                    </p>
                                  </div>
                                </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                    <td width="100" class="tab-list" style="cursor: pointer;" @click="tabChange(3)">
                       <!-- background: #1e50ae; -->
                      <div align="center">
                        <p class="content"><a href="/#/shopping_mall">商城</a></p>
                        <!-- style="color: #ffffff;"  -->
                      </div>
                    </td>
                    <td width="100" class="tab-list" style="cursor: pointer;" @click="tabChange(4)">
                      <div align="center">
                        <p class="content"><a href="/web/main/03.html">服务网点</a></p>
                      </div>
                    </td>
                    
                    <!-- <td width="100" class="tab-list" style="cursor: pointer;" @click="tabChange(6)">
                      <div align="center">
                        <p class="content"><a href="/web/main/05-01.html">会员中心</a></p>
                      </div>
                    </td> -->
                    <td width="100" class="tab-list" style="cursor: pointer;" @click="tabChange(7)">
                      <div align="center">
                        <p class="content"><a href="/web/main/06.html">专家介绍</a></p>
                      </div>
                    </td>
                    <td width="100" class="tab-list" style="cursor: pointer;" @click="tabChange(5)">
                      <div align="center">
                        <p class="content"><a href="/web/main/04.html">关于我们</a></p>
                      </div>
                    </td>
                    <td width="100" class="tab-list" style="cursor: pointer;">
                      <div align="center">
                        <p class="content"><a href="/web/main/07-01.html">帮助中心</a></p>
                      </div>
                    </td>
                    <td width="100" style="cursor: pointer;">
                      <div class="user_avatar _user_avatar" v-if="isLogin">
                        <!-- <img class="_avatar_img" :src="imgUrl">  -->
                         <div style="color:#5c307d;font-size:16px;">个人中心</div>
                        <ul class="data-list _data_list" style="font-size:14px;">
                          <li><a href="/#/web/setting">账号设置</a></li>
                          <li><a href="/#/web/vip_card_active">软件卡激活</a></li>
                          <li><a href="/#/web/purchased">我的已购</a></li>
                          <li><a href="/#/web/coordinator">班主任服务</a></li>
                          <li @click="webLogout">退出登录</li>
                        </ul>
                      </div>
                      <div class="_no_login" v-else>
                        <p class="content" style="text-align: center;"><a href="/#/web_login_register">登录/注册</a></p>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        
        <div :class="[`${pageClass}-main`]">
            <div :class="[`${pageClass}-main-content`]">
                <div :class="[`${pageClass}-main-content-box`]">
                    <div :class="[`${pageClass}-main-content-box-nav`]">
                        <div :class="[`${pageClass}-main-content-box-nav-user`]">
                            <img :src="avatar" />
                        </div>
                        <p class="name">{{ fullName }}</p>
                        <div :class="[`${pageClass}-main-content-box-nav-list`]">
                            <el-menu
                                router 
                                text-color="#5c307d"
                                active-text-color="#ffffff"
                                :default-active="$route.path"
                                class="el-menu-vertical-demo"
                            >
                            <!-- <el-menu-item index="/my-personal/my_evaluation">
                                <span slot="title">我的测评</span>
                            </el-menu-item>
                            <el-menu-item index="/my-personal/wrong_topic">
                                <span slot="title">错题本</span>
                            </el-menu-item>
                            <el-menu-item index="/my-personal/evaluation_record">
                                <span slot="title">测评记录</span>
                            </el-menu-item> -->
                            <el-menu-item index="/web/setting">
                                <span slot="title">账号设置</span>
                            </el-menu-item>
                            <el-menu-item index="/web/vip_card_active">
                                <span slot="title">软件卡激活</span>
                            </el-menu-item>
                            <el-menu-item index="/web/purchased">
                                <span slot="title">我的已购</span>
                            </el-menu-item>
                            <el-menu-item index="/web/coordinator">
                                <span slot="title">班主任服务</span>
                            </el-menu-item>

                            
                            </el-menu>
                        </div>
                    </div>
                    <div :class="[`${pageClass}-main-content-box-right`]">
                        <router-view />
                    </div>
                </div>
            </div>
        </div>
        <div :class="[`${pageClass}-footer`]">
            <layout-footer></layout-footer>
        </div>
    </div>
</template>

<script>
import layoutHeader from '@/components/header/header'
import layoutFooter from '@/components/footer/footer'
import $ from "jquery"
import config from '@/config/config.js'

export default {
    name : 'web-layout',
    data() {
        return {
            baseUrl: `${config.backURL}/`,
            imgUrl: '',
            isLogin: false,
            pageClass: 'web-layout',
            fullName: '',
            avatar: ''
        }
    },
    methods: {
      toSetting () {
        window.location.href = '/#/web/setting'
      },
      toPurchased () {
        window.location.href = '/#/web/purchased'
      },
      webLogout() {
        localStorage.clear()
        window.location.href = '/web/index.html'
      }
    },
    components:{
        layoutHeader,
        layoutFooter
    },
    created() {
        let user_json = localStorage.getItem('userinfo');
        const user = JSON.parse(user_json);
        this.fullName = user.nickname || user.fullName
        this.avatar =  user.avatar
    },
    mounted() {
      var userLogin = localStorage.getItem('isLogin') || ''
        if (userLogin === 'true') {
          var userinfo = JSON.parse(localStorage.getItem('userinfo'))
          try {
            this.imgUrl = this.baseUrl +  userinfo.avatar
          } catch (error) {
            this.imgUrl = require('../../../../public/web/images/user.png')
          }
          this.isLogin = true
        } else {
          this.isLogin = false
        }
        this.$root.eventHub.$on('updata-user-info', () => {
            let user_json = localStorage.getItem('userinfo');
            const user = JSON.parse(user_json);
            this.fullName = user.nickname || user.fullName
            this.avatar = user.avatar
        })

        this.$root.eventHub.$on('updata-user-avatar', (avatar) => {
            this.avatar = avatar
        })

        $(function () {
          $('.tab-list').hover(function () {
            $(this).find('#_arrow_nav').attr('src', require('../../../../public/web/images/arrow_nav_u.png'));
            $(this).addClass('active')
            if ($(this).index() == 3) {
              $('._product_list').show()
            }
          }, function () {
            $(this).find('#_arrow_nav').attr('src', require('../../../../public/web/images/arrow_nav_d.png'));
            $(this).removeClass('active')
            if ($(this).index() == 3) {
              $('._product_list').hide()
            }
          })
          $('._user_avatar').hover(function() {
            $('._data_list').show()
          }, function() {
            $('._data_list').hide()
          })
        })
    }
}
</script>
<style lang="scss" scoped>
  .shopping_mall {
    font-size: 16px;
    .header {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 100;
      background: #fff;
      width: 100%;
      // height: 120px;
      // overflow: hidden;
      .h120 {
        height: 120px;
      }
    }
    .tab-list {
      height: 120px;
    }
    .header-sticky {
      width: 100%;
      height: 120px;
    }
    .text-01 {
      margin:  0 auto;
      font-size: 16px;
    }
    .active {
      background: #1e50ae;
    }

    .active a {
      color: #fff;
    }

    .active a:hover {
      color: #fff;
    }

    .product_list {
      width: 100%;
      position: fixed;
      top: 120px;
      left: 0;
      z-index: 2;
      display: none;
    }
    td {
      // line-height: 200%;
      .buy-btn {
        cursor: pointer;
      }
    }

    .t-header td {
      height: 75px;
    }
    .t-content td, .t-content td p {
      line-height: 2;
      padding: 8px 10px;
    }

    /deep/ .login {
      top: 0;
    }

    .header .user_avatar img {
      width: 35px;
      height: 35px;
      border-radius: 35px;
      border: 2px solid #eee;
      display: inline-block;
    }
    .user_avatar {
      position: relative;
      text-align: center;
    }
    .data-list {
      width: 100px;
      display: block;
      position: absolute;
      top: 23px;
      left: 0px;
      background-color: #fff;
      list-style: none;
      z-index: 100;
      border-radius: 4px;
      padding: 10px 0;
      display: none;
      box-shadow: 0px 0px 8px #ccc;
    }
    .data-list li {
      width: 100%; 
      height: 30px;
      line-height: 30px;
      text-align: center;
    }
    .data-list li:hover {
      background-color: #1e50ae;
      color: #fff;
    }

    .web-layout-main {
      top: 120px;
    }


    
  }

  
 
</style>
<style lang="stylus" scoped>
    html, body {
        height:100%;
        margin:0;
        padding:0;
        overflow:hidden
    }
  .web-layout {
        height:100%;
        &-header {
            // height: 120px;
            width:100%;
            position:absolute;
            z-index:100;
            top:0;
        }
        &-main {
            width:100%;
            overflow:auto;
            position: absolute;
            z-index: 10;
            bottom: 43px;
            background-color: #efefef;
            &-content {
                width: 1520px;
                height: 100%;
                margin: 0 auto;
                position: relative;
                &-box {
                    position: absolute;
                    top: 20px;
                    bottom: 20px;
                    left: 0;
                    right: 0;
                    z-index: 20;
                    display: flex;
                    &-nav {
                        width: 300px;
                        height: 100%;
                        background-color: #ffffff;
                        margin-right: 27px;

                        &-user {
                            width: 160px;
                            height: 160px;
                            border-radius: 100px;
                            overflow: hidden;
                            margin-top: 40px;
                            margin-left: 70px;
                            img {
                                width: 160px;
                                height: 160px;
                            }
                        }
                        &-list {
                            width: 100%;
                            margin-top: 30px;

                            /deep/ .el-menu-item {
                                left: 0px;
                                padding-left: 50px !important;
                                font-size 18px;
                            }

                            /deep/ .is-active {
                                background-color: #5c307d;
                            }
                        }
                        .name {
                            width: 270px;
                            height: 80px;
                            line-height: 80px;
                            text-align: center;
                            color: #585858;
                            margin: 0 auto;
                            font-size: 18px;
                            border-bottom: 2px solid #d2d2d2;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    &-right {
                        flex: 1;
                        background-color: #ffffff;
                        position: relative;
                    }
                }
            }
        }

        
        &-main::-webkit-scrollbar{
            width:0;
        }
        &-footer {
            height:43px;
            width:100%;
            position:absolute;
            z-index:200;
            bottom:0;
        }
    }
</style>
